export default __webpack_public_path__ + "static/media/Type D.92a55663.PNG";